import { enGB } from 'date-fns/locale';
import { isValid, parse } from 'date-fns';
import { emptyFieldError } from './generic-validator';

export function validateDate(date: string): string {
    if (date === '') {
        return emptyFieldError;
    }

    const validDate = isDateValid(date);

    const age = getAge(date);
    const isWithinAge = age >= 18 && age < 130;

    if (!validDate) {
        return 'A valid date needs to be entered';
    }
    if (!isWithinAge) {
        return 'Buyers are required to be 18 years of age or more';
    }
    return '';
}

function getAge(date: string): number {
    const today = new Date();
    const birthDate = parse(date, 'P', new Date(), { locale: enGB });
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export const isDateValid = (dateString: string): boolean => {
    const validDateFormatRegex = /^(?:\d{2}\/){2}\d{4}$/g;
    const isValidDateFormat = validDateFormatRegex.test(dateString);

    if (!isValidDateFormat) {
        return false;
    }

    const parsedDate = parse(dateString, 'P', new Date(), { locale: enGB });
    return isValid(parsedDate);
};
